import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/order.service';
import { Store } from 'src/app/models/store';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-redeem-status',
  templateUrl: './redeem-status.component.html',
  styleUrls: ['./redeem-status.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedeemStatusComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private orderService:OrderService,
    private router: Router,
    private cdr: ChangeDetectorRef) { }

  offerId;
    offerItem;
    store;
    redeemAmount;
    redeemId;
    redeem;
    isLoading = true;
    hash

  ngOnInit() {
    this.hash = this.route.snapshot.paramMap.get('hash');
    this.offerId = this.route.snapshot.paramMap.get('offerId');
    this.redeemId = this.route.snapshot.paramMap.get('redeemId');

    this.orderService.getOfferItemWithHash(this.hash, this.offerId).pipe(
      switchMap(offer => {
        this.offerItem = offer;
        this.redeemAmount = offer.total_list_price - offer.redeemed_amount;
        this.isLoading = false;
        const storeid = localStorage.getItem('currentStore') || offer.offer.store;
        return forkJoin({
          store: this.orderService.getStoreInfo(storeid),
          history: this.orderService.redeemHistory(this.hash, this.offerId, this.redeemId)
        });
      })
    ).subscribe(({ store, history }) => {
      this.store = Object.assign(new Store(), store);
      this.redeem = history;
      this.cdr.markForCheck();
    })
  }

  goBack(){
    window.history.back()
  }
}
